<div class="fixedSurface__background">
  <app-ds-background-surface
    [type]="surface"
    [position]="'fixed'"
    [left]="'0px'"
    [right]="'0px'"
    [bottom]="'0px'"
    [padding]="'24px 16px 32px'"
    [boxShadow]="boxShadow">
    <ng-content></ng-content>
  </app-ds-background-surface>
</div>